import {Service} from '@/types/service'
import apiClient from '@/utils/axios'
import {apiEndPoints} from '@/utils/constant'
import {AxiosResponse} from 'axios'

const {SERVICE_URL} = apiEndPoints

interface Services {
    get(category: string): Promise<AxiosResponse<Service[]>>
    getById(id: string): Promise<AxiosResponse<Service>>
    create(payload: FormData): Promise<AxiosResponse<Service>>
    update(id: string, question: FormData): Promise<AxiosResponse<Service>>
    delete(id: string): Promise<AxiosResponse<string>>
  }

const service: Services = {
  async get(query) {
    const q = query ? `?${query}` : ''
    const response = await apiClient.get(`${SERVICE_URL}/${q}`)
    return response
  },

  async create(payload) {
    const response = await apiClient.post(SERVICE_URL, payload)
    return response
  },

  async getById(id) {
    const response = await apiClient.get(`${SERVICE_URL}/${id}`)
    return response
  },

  async update(id, payload) {
    const response = await apiClient.put(`${SERVICE_URL}/${id}`, payload)
    return response
  },

  async delete(id) {
    const response = await apiClient.delete(`${SERVICE_URL}/${id}`)
    return response
  },
}

export {service}
